/// <reference types="@types/google.maps" />

import {
	Component,
	AfterViewInit,
	OnInit,
	ViewChild,
	ElementRef,
	ViewContainerRef,
	ComponentRef,
	Injector,
} from '@angular/core';
import { GoogleMapService } from '../GoogleMapsService';
import { ButtonComponent } from 'src/app/shared/button/button.component';

@Component({
	selector: 'app-google-maps',
	templateUrl: './google-maps.component.html',
	styleUrls: ['./google-maps.component.scss'],
})
export class GoogleMapsComponent implements OnInit, AfterViewInit {
	@ViewChild('mapContainer', { static: false }) mapRef: ElementRef;
	@ViewChild('element', { read: ViewContainerRef })
		container: ViewContainerRef;
	private lat: number;
	private lng: number;
	private map: google.maps.Map;
	private mapOptions: google.maps.MapOptions;
	private _componentFactoryResolver: any;
	private _injector: Injector;
	
	private customMapStyle: any = [
		{
		  "featureType": "administrative.land_parcel",
		  "elementType": "labels",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "landscape.man_made",
		  "elementType": "geometry.fill",
		  "stylers": [
			{
			  "color": "#e3e3e3"
			}
		  ]
		},
		{
		  "featureType": "landscape.natural",
		  "elementType": "geometry.fill",
		  "stylers": [
			{
			  "color": "#dbeccc"
			}
		  ]
		},
		{
		  "featureType": "poi",
		  "elementType": "labels.text",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "poi.business",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "road",
		  "elementType": "labels.icon",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "road.highway",
		  "elementType": "geometry.fill",
		  "stylers": [
			{
			  "color": "#c9c9c9"
			}
		  ]
		},
		{
		  "featureType": "road.highway",
		  "elementType": "geometry.stroke",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "road.local",
		  "elementType": "labels",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "transit",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "water",
		  "elementType": "geometry.fill",
		  "stylers": [
			{
			  "color": "#d1f1ff"
			}
		  ]
		}
	  ];

	constructor(private gmapService: GoogleMapService) {
		this.lat = -32.8310356; //-33.87;
		this.lng = 147.3190045; //151.21;

		this.mapOptions = {
			center: { lat: this.lat, lng: this.lng },
			styles: this.customMapStyle,
			scrollwheel: true,
			zoom: 13,
			fullscreenControl: false,
			scaleControl: true,
			streetViewControl : true,
			restriction: {
				latLngBounds: {
					north: -28.1570082,
					south: -37.505063,
					west: 140.9992862,
					east: 153.6387228,
				},
				strictBounds: true,
			},
		};
	}

	ngAfterViewInit(): void {
		this.mapInitializer();
	}

	async mapInitializer() {
		console.debug(this.mapOptions.styles)
		this.map = await this.gmapService.initMap(
			this.mapRef.nativeElement,
			this.mapOptions
		);
		this.zoomToCurrentPosition();
		const currentLocationControlDiv = document.createElement('div');
		/* Create the Zoom to Current Geo-location Widget to add to map */
		const currentLocationControl = this.createCurrentLocationControl();
		// Append the control to the DIV.
		currentLocationControlDiv.appendChild(currentLocationControl);
		/* Add the control to the map */
		this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(
			currentLocationControlDiv
		);
	}

	ngOnInit() {
		
	}

	zoomToCurrentPosition() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position: GeolocationPosition) => {
					const pos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};

					this.map.setCenter(pos);
				},
				(e) => {
					console.debug(
						'Cannot zoom to current position : ',
						e.message
					);
				}
			);
		} else {
			// Browser doesn't support Geolocation
			console.debug("Browser doesn't support Geolocation");
		}
	}

	private _createButton(): [ComponentRef<ButtonComponent>, ButtonComponent] {
		const componentFactory =
			this._componentFactoryResolver.resolveComponentFactory(
				ButtonComponent
			);
		const componentRef = componentFactory.create(this._injector);

		const componentInstance = componentRef.instance;

		return [componentRef, componentInstance];
	}

	private createCurrentLocationControl() {
		//const [componentRef, componentInstance] = this._createButton();
		//componentInstance.title = 'North';
		//componentInstance.class = 'currentlocation';
		//componentInstance.textContent = 'Center Map';

		//this.container.insert(componentRef.hostView);
		// componentInstance.addEventListener('click', () => {
		// 	this.zoomToCurrentPosition();
		// });
		//return componentInstance;

		const controlButton = document.createElement('button');
		controlButton.type = 'button';
		controlButton.setAttribute('class', 'currentlocation');
		controlButton.textContent = 'Center Map';
		controlButton.title = 'Click to recenter the map at current location';

		// Set CSS for the control.
		controlButton.style.backgroundColor = '#fff';
		controlButton.style.border = '2px solid #fff';
		controlButton.style.borderRadius = '3px';
		controlButton.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
		controlButton.style.color = 'rgb(25,25,25)';
		controlButton.style.cursor = 'pointer';
		controlButton.style.fontFamily = 'Roboto,Arial,sans-serif';
		controlButton.style.fontSize = '16px';
		controlButton.style.lineHeight = '38px';
		controlButton.style.margin = '8px 0 22px';
		controlButton.style.padding = '0 5px';
		controlButton.style.textAlign = 'center';

		controlButton.addEventListener('click', () => {
			this.zoomToCurrentPosition();
		});

		return controlButton;
	}
}
